module.exports = __webpack_public_path__ + "img/geometric-03012025.4d58600e.jpg";